import ThemeProvider from '@mui/material/styles/ThemeProvider';
import theme from './theme';
import OOBAModal from 'Common/OOBAModal';
import OOBAErrorModal from 'Common/OOBAErrorModal';
import Main from '../components/Main';
import React from 'react';
import { createRoot } from 'react-dom/client';

export default (id, isFinemark) => {
    const rootNode = document.getElementById(id);
    const root = createRoot(rootNode);

    root.render(
        <div>
            <ThemeProvider theme={theme}>
                <OOBAModal></OOBAModal>
                <OOBAErrorModal></OOBAErrorModal>
                <Main isFinemark={isFinemark} />
            </ThemeProvider>
        </div>
)};